import { PlaybackTracker } from './playback_tracker';
import { LIVE_PROGRESS_REPORTING_INTERVAL } from 'configuration/defaults';

export class LivePlaybackTracker extends PlaybackTracker {
    constructor(playerAdapter, progressInterval) {
        super(playerAdapter, progressInterval);
        this.progressInterval = progressInterval || LIVE_PROGRESS_REPORTING_INTERVAL;
    }

    getPlaybackStats(player) {
        const stats = super.getPlaybackStats(player);

        // These values are irrelevant with live video because it does not have a fixed duration
        delete stats['Video Offset'];
        delete stats['Video Duration'];
        delete stats['Video Percent Complete'];

        return stats;
    }
}